module.exports = __webpack_public_path__ + "static/media/women-owned.0b9587fc.png";